export const translations = {
  cityStopType: {
    pt: 'Cidade',
    en: 'City',
    es: 'Ciudad',
    de: 'Stadt',
  },
  coordinatesStopType: {
    pt: 'Latitude/Longitude',
    en: 'Latitude/Longitude',
    es: 'Latitud/Longitud',
    de: 'Breitengrad/Längengrad',
  },
};